import React from 'react';
import queryString from 'query-string';
import {withRouter} from "react-router-dom";
import withHeader from "../../../hocs/withHeader";
import FacebookAuthComponent from "./facebook/FacebookAuthComponent";
import GoogleAuthComponent from './google/GoogleAuthComponent';
import withFooter from "../../../hocs/withFooter";

function SocialAuthPage(props) {
    const urlParams = queryString.parse(props.location.search);

    if((typeof urlParams.state === "undefined") || (urlParams.state && !["facebook", "google"].includes(urlParams.state))) {
        props.history.push("/login");
    }

    var authComponent;
    switch (urlParams.state) {
        case "facebook":
            authComponent = (<FacebookAuthComponent/>);
            break;
        case "google":
            authComponent = (<GoogleAuthComponent/>);
            break;
        default:
            authComponent = (<React.Fragment/>);
            break;
    }

    return authComponent;
}

export default withRouter(withFooter(withHeader(SocialAuthPage)));